import { MemberService } from "components/member-service/MemberService";
import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";

const WelcomeBackCard = () => {
    return (
        <CardTemplate className="text-base-content min-h-[308px] tablet:min-h-[308px]">
            <div
                data-testid="welcome-back-content"
                className="font-medium text-base-content text-base flex flex-col gap-4 pt-10"
            >
                <h2 className="text-xl font-semibold text-base-content text-center">Welcome back!</h2>
                <p className="text-sm leading-[1.25] tracking-normal text-base-content pr-1 font-medium">
                    If you are looking to review the coverage you applied for, have questions about making any changes, or need
                    anything else during your application review process, please reach out to us!
                </p>

                <MemberService email={false} titleClassName="text-black/90" />

                <HoursOperation className="text-black/90" />
            </div>
        </CardTemplate>
    );
};

export default WelcomeBackCard;
